/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite';
import {red} from '../../colors';

const styles = StyleSheet.create({
	errorMessage: {
		color: red
	}
})

export default styles;
